// extracted by mini-css-extract-plugin
export default {"form":"MagicLinkModal_form__iTslW","submitButton":"MagicLinkModal_submitButton__IPE+F"};